import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

export const NoShowModal = ({
  isOpen,
  onClose,
  operation,
  onConfirm,
}) => {
  const { t } = useTranslation();
  
  const [reason, setReason] = useState('');
  const [releaseRoom, setReleaseRoom] = useState(true);
  const [contactAttempts, setContactAttempts] = useState('');

  if (!isOpen || !operation) return null;

  const handleConfirm = () => {
    if (!reason.trim()) return;
    onConfirm(operation.id, reason.trim(), releaseRoom);
  };

  const commonReasons = [
    t('noShowReasonNotArrived'),
    t('noShowReasonNoResponse'),
    t('noShowReasonLastMinute'),
    t('noShowReasonTravelChange'),
    t('noShowReasonTransportation')
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-red-50 border-b border-slate-200 px-6 py-4 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3 rtl:space-x-reverse">
              <div className="p-2 bg-red-100 rounded-lg">
                <AlertTriangle size={20} className="text-red-600" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-red-900">
                  {t('markAsNoShow')}
                </h2>
                <p className="text-sm text-red-700">{operation.reqClientName} - {operation.unitName} - {operation.unitCode}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 text-red-400 hover:text-red-600 hover:bg-red-100 rounded-lg transition-colors duration-200"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Booking Details */}
          <div className="bg-slate-50 rounded-xl p-4">
            <h4 className="font-medium text-slate-900 mb-3">
              {t('bookingDetails')}:
            </h4>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-slate-600">{t('guest')}:</span>
                <span className="font-medium text-slate-900">{operation.reqClientName}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-600">{t('unit')}:</span>
                <span className="font-medium text-slate-900">{operation.unitName} - {operation.unitCode}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-600">{t('expectedTime')}:</span>
                <span className="font-medium text-slate-900">{moment.utc(operation.reqTo).format('HH:mm')}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-600">{t('guestsCount')}:</span>
                <span className="font-medium text-slate-900">{operation.reqGuests}</span>
              </div>
            </div>
          </div>

          {/* Contact Attempts */}
          {/* <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">
              {t('contactAttempts')}:
            </label>
            <textarea
              value={contactAttempts}
              onChange={(e) => setContactAttempts(e.target.value)}
              rows={2}
              className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
              placeholder={t('contactAttemptsPlaceholder')}
            />
          </div> */}

          {/* Reason Selection */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-3">
              {t('noShowReason')}:
            </label>
            
            {/* Common Reasons */}
            <div className="space-y-2 mb-3">
              {commonReasons.map((commonReason, index) => (
                <button
                  key={index}
                  onClick={() => setReason(commonReason)}
                  className={`w-full rtl:text-start p-3 border border-slate-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors duration-200 text-sm ${
                    reason === commonReason ? 'border-blue-500 bg-blue-50' : ''
                  }`}
                >
                  {commonReason}
                </button>
              ))}
            </div>

            {/* Custom Reason */}
            {/* <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={3}
              className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
              placeholder={t('customReasonPlaceholder')}
            /> */}
          </div>

          {/* Room Release Option */}
          {/* <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
            <label className="flex items-start space-x-3 rtl:space-x-reverse cursor-pointer">
              <input
                type="checkbox"
                checked={releaseRoom}
                onChange={(e) => setReleaseRoom(e.target.checked)}
                className="w-4 h-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500 mt-0.5"
              />
              <div>
                <span className="text-sm font-medium text-blue-900">
                  {t('releaseRoomForBooking')}
                </span>
                <p className="text-xs text-blue-700 mt-1">
                  {t('releaseRoomDescription')}
                </p>
              </div>
            </label>
          </div> */}
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-white border-t border-slate-200 px-6 py-4 rounded-b-2xl">
          <div className="flex space-x-3 rtl:space-x-reverse">
            <button
              onClick={handleConfirm}
              disabled={!reason.trim()}
              className="flex-1 bg-red-600 hover:bg-red-700 disabled:bg-slate-300 disabled:cursor-not-allowed text-white font-semibold py-3 px-4 rounded-xl transition-colors duration-200 flex items-center justify-center space-x-2 rtl:space-x-reverse"
            >
              <AlertTriangle size={18} />
              <span>{t('confirmNoShow')}</span>
            </button>
            <button
              onClick={onClose}
              className="flex-1 bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold py-3 px-4 rounded-xl transition-colors duration-200 flex items-center justify-center space-x-2 rtl:space-x-reverse"
            >
              <X size={18} />
              <span>{t('Cancel')}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};